import React from 'react';
require(`../assets/${process.env.PAGE}/css/components/text-with-line.css`);

const TextWithLine = (props) => {
	return (
			  <div className={'text-with-line'}>
			  <span className={'text-without-line'}>
			  	{props.value}
			  </span>
			  </div>
			);
} 

export default TextWithLine;



/** WEBPACK FOOTER **
 ** ./src/components/TextWithLine.js
 **/